"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var get_1 = __importDefault(require("lodash/get"));
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var general_1 = require("utils/general");
var SurveyButton = (0, styles_1.styled)(TextButton_1.default, { shouldForwardProp: (0, general_1.omitProps)('colorOnHover') })(function (_a) {
    var theme = _a.theme, colorOnHover = _a.colorOnHover;
    return ({
        padding: 0,
        minWidth: theme.spacing(4),
        ':hover': colorOnHover && {
            color: (0, get_1.default)(theme.palette, colorOnHover || ''),
            backgroundColor: 'transparent',
        },
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(SurveyButton, { color: 'inherit' });
